import classnames from "classnames";
import { nSpaces } from "../../../utils/utils";

export const Fake = ({ className, size }) => (
    <span className={classnames("fake", className)}>{nSpaces(size)}</span>
);
